// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body[data-theme='dark'] {
  background-color: var(--dark-bg);
  color: var(--dark-text);
}

body[data-theme='dark'] .ant-layout {
  background-color: var(--dark-bg);
}

body[data-theme='dark'] .site-layout-background {
  background: var(--dark-bg);
}

body[data-theme='dark'] .ant-menu {
  background: var(--dark-bg);
  color: var(--dark-text);
  border-right: 1px solid var(--dark-border);
}

body[data-theme='dark'] .ant-menu-item {
  color: rgba(255, 255, 255, 0.65);
}

body[data-theme='dark'] .ant-menu-item-selected {
  background-color: var(--color-primary)  !important;
  color: #fff !important;
}

body[data-theme='dark'] .ant-card {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-card-head {
  background-color: var(--dark-bg-header) !important;
  border-bottom-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-card-bordered {
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-table {
  background-color: var(--dark-bg-secondary) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-table-thead > tr > th {
  background-color: var(--dark-bg-header) !important;
  color: var(--dark-text) !important;
  border-bottom: 1px solid var(--dark-border) !important;
}

body[data-theme='dark'] .ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-table-tbody > tr:hover > td {
  background-color: var(--dark-bg-header) !important;
}

body[data-theme='dark'] .ant-list-item {
  border-bottom-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-list-item-meta-title {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-list-item-meta-description {
  color: var(--dark-text-muted) !important;
}

body[data-theme='dark'] .ant-divider {
  border-top-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-dropdown-menu {
  background-color: var(--dark-bg-secondary) !important;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.48), 0 6px 16px 0 rgba(0, 0, 0, 0.32), 0 9px 28px 8px rgba(0, 0, 0, 0.2) !important;
}

body[data-theme='dark'] .ant-dropdown-menu-item {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-dropdown-menu-item:hover {
  background-color: var(--dark-bg-header) !important;
}

body[data-theme='dark'] .ant-input {
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

/* Number input (InputNumber) wrapper and inner input */
body[data-theme='dark'] .ant-input-number,
body[data-theme='dark'] .ant-input-number-input-wrap,
body[data-theme='dark'] .ant-input-number-input {
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}
body[data-theme='dark'] .ant-input-number:hover,
body[data-theme='dark'] .ant-input:hover,
body[data-theme='dark'] .ant-select-selector:hover {
  border-color: var(--color-primary) !important;
}

body[data-theme='dark'] .ant-input-affix-wrapper {
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-input-affix-wrapper .ant-input {
  background-color: transparent !important;
}

body[data-theme='dark'] .ant-input-affix-wrapper:hover {
  border-color: var(--color-primary)  !important;
}

body[data-theme='dark'] .ant-input-search-icon {
  color: var(--dark-text-muted) !important;
}

body[data-theme='dark'] .ant-btn {
  background-color: transparent !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-btn-primary {
  background-color: var(--color-primary)  !important;
  border-color: var(--color-primary)  !important;
  color: #fff !important;
}

body[data-theme='dark'] .ant-btn-text {
  background: transparent !important;
  border-color: transparent !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-switch {
  background-color: rgba(255, 255, 255, 0.3) !important;
}

body[data-theme='dark'] .ant-switch-checked {
  background-color: var(--color-primary)  !important;
}

body[data-theme='dark'] .ant-statistic-title {
  color: var(--dark-text-muted) !important;
}

body[data-theme='dark'] .ant-statistic-content {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] a {
  color: var(--color-primary)  !important;
}

body[data-theme='dark'] .ant-layout-header {
  background-color: var(--dark-bg-secondary) !important;
  border-bottom: 1px solid var(--dark-border) !important;
}

body[data-theme='dark'] input[type="checkbox"] {
  accent-color: var(--color-primary)  !important;
}

body[data-theme='dark'] label {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-badge-status-text {
  color: rgba(255, 255, 255, 0.65) !important;
}

body[data-theme='dark'] .ant-avatar {
  background-color: var(--color-primary)  !important;
}

body[data-theme='dark'] .ant-typography {
  color: var(--dark-text) !important;
}

/* Tablo pagination dark mode */
body[data-theme='dark'] .ant-pagination {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-pagination-item {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-pagination-item a {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-pagination-item-active {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

body[data-theme='dark'] .ant-pagination-item-active a {
  color: #fff !important;
}

body[data-theme='dark'] .ant-pagination-prev,
body[data-theme='dark'] .ant-pagination-next {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-pagination-options {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-pagination-options .ant-select {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

/* Tag dark mode */
body[data-theme='dark'] .ant-tag {
  background-color: var(--dark-bg-header) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-tag-blue {
  background-color: rgba(24, 144, 255, 0.2) !important;
  border-color: #1890ff !important;
  color: #1890ff !important;
}

body[data-theme='dark'] .ant-tag-orange {
  background-color: rgba(255, 193, 7, 0.2) !important;
  border-color: #ffc107 !important;
  color: #ffc107 !important;
}

body[data-theme='dark'] .ant-tag-red {
  background-color: rgba(255, 77, 79, 0.2) !important;
  border-color: #ff4d4f !important;
  color: #ff7875 !important;
}

body[data-theme='dark'] .ant-tag-green {
  background-color: rgba(82, 196, 26, 0.2) !important;
  border-color: #52c41a !important;
  color: #73d13d !important;
}

body[data-theme='dark'] .ant-tag-volcano {
  background-color: rgba(255, 87, 34, 0.2) !important;
  border-color: #ff5722 !important;
  color: #ff8a65 !important;
}

body[data-theme='dark'] .ant-tag-yellow {
  background-color: rgba(250, 173, 20, 0.2) !important;
  border-color: #faad14 !important;
  color: #ffc53d !important;
}

body[data-theme='dark'] .ant-tag-purple {
  background-color: rgba(114, 46, 209, 0.2) !important;
  border-color: #722ed1 !important;
  color: #9254de !important;
}

/* Table styles for Talepler page */
.dark-table .ant-table-thead > tr > th {
  background: var(--dark-bg-secondary) !important;
  border-bottom: 2px solid var(--dark-border) !important;
  color: var(--dark-text) !important;
  font-weight: 600 !important;
  padding: 16px 12px !important;
}

.dark-table .ant-table-tbody > tr > td {
  background: var(--dark-bg) !important;
  border-bottom: 1px solid var(--dark-border) !important;
  color: var(--dark-text) !important;
  padding: 12px !important;
}

.dark-table .ant-table-tbody > tr:hover > td {
  background: var(--dark-bg-secondary) !important;
}

/* Light mode table styles */
.ant-table-thead > tr > th {
  background: #fafafa !important;
  border-bottom: 2px solid #d9d9d9 !important;
  color: #333 !important;
  font-weight: 600 !important;
  padding: 16px 12px !important;
}

.ant-table-tbody > tr > td {
  background: #fff !important;
  border-bottom: 1px solid #f0f0f0 !important;
  color: #333 !important;
  padding: 12px !important;
}

.ant-table-tbody > tr:hover > td {
  background: #f5f5f5 !important;
}

/* Row spacing */
.table-row-even {
  margin-bottom: 4px;
}

.table-row-odd {
  margin-bottom: 4px;
}

/* Modal dark mode styles */
body[data-theme='dark'] .ant-modal-content {
  background-color: var(--dark-bg-secondary) !important;
  border: 1px solid var(--dark-border) !important;
}

body[data-theme='dark'] .ant-modal-header {
  background-color: var(--dark-bg-header) !important;
  border-bottom: 1px solid var(--dark-border) !important;
}

body[data-theme='dark'] .ant-modal-title {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-modal-close {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-modal-body {
  background-color: var(--dark-bg-secondary) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-modal-footer {
  background-color: var(--dark-bg-secondary) !important;
  border-top: 1px solid var(--dark-border) !important;
}

/* Select dark mode styles */
body[data-theme='dark'] .ant-select-selector {
  background-color: var(--dark-bg) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-select-selection-item {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-select-selection-placeholder {
  color: var(--dark-text-muted) !important;
}

body[data-theme='dark'] .ant-select-arrow {
  color: var(--dark-text-muted) !important;
}

body[data-theme='dark'] .ant-select-dropdown {
  background-color: var(--dark-bg-secondary) !important;
  border: 1px solid var(--dark-border) !important;
}

/* Popconfirm/Popover in form area */
body[data-theme='dark'] .ant-popover-inner,
body[data-theme='dark'] .ant-popconfirm .ant-popover-inner {
  background-color: var(--dark-bg-secondary) !important;
  color: var(--dark-text) !important;
}
body[data-theme='dark'] .ant-popover-inner-content {
  color: var(--dark-text) !important;
}
body[data-theme='dark'] .ant-popover-arrow::before {
  background: var(--dark-bg-secondary) !important;
}

body[data-theme='dark'] .ant-select-item {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-select-item-option-selected {
  background-color: var(--dark-bg-header) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-select-item-option:hover {
  background-color: var(--dark-bg-header) !important;
}

/* Tooltip dark mode styles */
body[data-theme='dark'] .ant-tooltip-inner {
  background-color: var(--dark-bg-header) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-tooltip-arrow::before {
  background-color: var(--dark-bg-header) !important;
}

/* Alert dark mode styles */
body[data-theme='dark'] .ant-alert {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-alert-message {
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-alert-description {
  color: var(--dark-text-muted) !important;
}

/* Spin dark mode styles */
body[data-theme='dark'] .ant-spin-dot-item {
  background-color: var(--color-primary) !important;
}

body[data-theme='dark'] .ant-spin-text {
  color: var(--dark-text) !important;
}

/* Descriptions dark mode styles */
body[data-theme='dark'] .ant-descriptions {
  background-color: var(--dark-bg-secondary) !important;
  color: var(--dark-text) !important;
}

body[data-theme='dark'] .ant-descriptions-item-label {
  color: var(--dark-text) !important;
  background-color: var(--dark-bg-header) !important;
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-descriptions-item-content {
  color: var(--dark-text) !important;
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: var(--dark-bg-header) !important;
  border-color: var(--dark-border) !important;
}

body[data-theme='dark'] .ant-descriptions-bordered .ant-descriptions-item-content {
  background-color: var(--dark-bg-secondary) !important;
  border-color: var(--dark-border) !important;
}

/* Table Summary dark mode styles */
body[data-theme='dark'] .ant-table-summary {
  background-color: var(--dark-bg-secondary) !important;
}

body[data-theme='dark'] .ant-table-summary tr > td {
  background-color: var(--dark-bg-header) !important;
  border-color: var(--dark-border) !important;
  color: var(--dark-text) !important;
}
`, "",{"version":3,"sources":["webpack://./src/DarkMode.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;EAClD,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;EACtD,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,8HAA8H;AAChI;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,uDAAuD;AACvD;;;EAGE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;AACA;;;EAGE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qDAAqD;EACrD,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,qDAAqD;EACrD,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,sDAAsD;EACtD,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA,oCAAoC;AACpC;;EAEE,qDAAqD;EACrD,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,6BAA6B;AAC7B;EACE,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA,mCAAmC;AACnC;EACE,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,kCAAkC;AACpC","sourcesContent":["@import './index.css';\n\nbody[data-theme='dark'] {\n  background-color: var(--dark-bg);\n  color: var(--dark-text);\n}\n\nbody[data-theme='dark'] .ant-layout {\n  background-color: var(--dark-bg);\n}\n\nbody[data-theme='dark'] .site-layout-background {\n  background: var(--dark-bg);\n}\n\nbody[data-theme='dark'] .ant-menu {\n  background: var(--dark-bg);\n  color: var(--dark-text);\n  border-right: 1px solid var(--dark-border);\n}\n\nbody[data-theme='dark'] .ant-menu-item {\n  color: rgba(255, 255, 255, 0.65);\n}\n\nbody[data-theme='dark'] .ant-menu-item-selected {\n  background-color: var(--color-primary)  !important;\n  color: #fff !important;\n}\n\nbody[data-theme='dark'] .ant-card {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-card-head {\n  background-color: var(--dark-bg-header) !important;\n  border-bottom-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-card-bordered {\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-table {\n  background-color: var(--dark-bg-secondary) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-table-thead > tr > th {\n  background-color: var(--dark-bg-header) !important;\n  color: var(--dark-text) !important;\n  border-bottom: 1px solid var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-table-tbody > tr > td {\n  border-bottom: 1px solid var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-table-tbody > tr:hover > td {\n  background-color: var(--dark-bg-header) !important;\n}\n\nbody[data-theme='dark'] .ant-list-item {\n  border-bottom-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-list-item-meta-title {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-list-item-meta-description {\n  color: var(--dark-text-muted) !important;\n}\n\nbody[data-theme='dark'] .ant-divider {\n  border-top-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-dropdown-menu {\n  background-color: var(--dark-bg-secondary) !important;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.48), 0 6px 16px 0 rgba(0, 0, 0, 0.32), 0 9px 28px 8px rgba(0, 0, 0, 0.2) !important;\n}\n\nbody[data-theme='dark'] .ant-dropdown-menu-item {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-dropdown-menu-item:hover {\n  background-color: var(--dark-bg-header) !important;\n}\n\nbody[data-theme='dark'] .ant-input {\n  background-color: var(--dark-bg) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\n/* Number input (InputNumber) wrapper and inner input */\nbody[data-theme='dark'] .ant-input-number,\nbody[data-theme='dark'] .ant-input-number-input-wrap,\nbody[data-theme='dark'] .ant-input-number-input {\n  background-color: var(--dark-bg) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\nbody[data-theme='dark'] .ant-input-number:hover,\nbody[data-theme='dark'] .ant-input:hover,\nbody[data-theme='dark'] .ant-select-selector:hover {\n  border-color: var(--color-primary) !important;\n}\n\nbody[data-theme='dark'] .ant-input-affix-wrapper {\n  background-color: var(--dark-bg) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-input-affix-wrapper .ant-input {\n  background-color: transparent !important;\n}\n\nbody[data-theme='dark'] .ant-input-affix-wrapper:hover {\n  border-color: var(--color-primary)  !important;\n}\n\nbody[data-theme='dark'] .ant-input-search-icon {\n  color: var(--dark-text-muted) !important;\n}\n\nbody[data-theme='dark'] .ant-btn {\n  background-color: transparent !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-btn-primary {\n  background-color: var(--color-primary)  !important;\n  border-color: var(--color-primary)  !important;\n  color: #fff !important;\n}\n\nbody[data-theme='dark'] .ant-btn-text {\n  background: transparent !important;\n  border-color: transparent !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-switch {\n  background-color: rgba(255, 255, 255, 0.3) !important;\n}\n\nbody[data-theme='dark'] .ant-switch-checked {\n  background-color: var(--color-primary)  !important;\n}\n\nbody[data-theme='dark'] .ant-statistic-title {\n  color: var(--dark-text-muted) !important;\n}\n\nbody[data-theme='dark'] .ant-statistic-content {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] a {\n  color: var(--color-primary)  !important;\n}\n\nbody[data-theme='dark'] .ant-layout-header {\n  background-color: var(--dark-bg-secondary) !important;\n  border-bottom: 1px solid var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] input[type=\"checkbox\"] {\n  accent-color: var(--color-primary)  !important;\n}\n\nbody[data-theme='dark'] label {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-badge-status-text {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n\nbody[data-theme='dark'] .ant-avatar {\n  background-color: var(--color-primary)  !important;\n}\n\nbody[data-theme='dark'] .ant-typography {\n  color: var(--dark-text) !important;\n}\n\n/* Tablo pagination dark mode */\nbody[data-theme='dark'] .ant-pagination {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-item {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-item a {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-item-active {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-item-active a {\n  color: #fff !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-prev,\nbody[data-theme='dark'] .ant-pagination-next {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-options {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-pagination-options .ant-select {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\n/* Tag dark mode */\nbody[data-theme='dark'] .ant-tag {\n  background-color: var(--dark-bg-header) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-tag-blue {\n  background-color: rgba(24, 144, 255, 0.2) !important;\n  border-color: #1890ff !important;\n  color: #1890ff !important;\n}\n\nbody[data-theme='dark'] .ant-tag-orange {\n  background-color: rgba(255, 193, 7, 0.2) !important;\n  border-color: #ffc107 !important;\n  color: #ffc107 !important;\n}\n\nbody[data-theme='dark'] .ant-tag-red {\n  background-color: rgba(255, 77, 79, 0.2) !important;\n  border-color: #ff4d4f !important;\n  color: #ff7875 !important;\n}\n\nbody[data-theme='dark'] .ant-tag-green {\n  background-color: rgba(82, 196, 26, 0.2) !important;\n  border-color: #52c41a !important;\n  color: #73d13d !important;\n}\n\nbody[data-theme='dark'] .ant-tag-volcano {\n  background-color: rgba(255, 87, 34, 0.2) !important;\n  border-color: #ff5722 !important;\n  color: #ff8a65 !important;\n}\n\nbody[data-theme='dark'] .ant-tag-yellow {\n  background-color: rgba(250, 173, 20, 0.2) !important;\n  border-color: #faad14 !important;\n  color: #ffc53d !important;\n}\n\nbody[data-theme='dark'] .ant-tag-purple {\n  background-color: rgba(114, 46, 209, 0.2) !important;\n  border-color: #722ed1 !important;\n  color: #9254de !important;\n}\n\n/* Table styles for Talepler page */\n.dark-table .ant-table-thead > tr > th {\n  background: var(--dark-bg-secondary) !important;\n  border-bottom: 2px solid var(--dark-border) !important;\n  color: var(--dark-text) !important;\n  font-weight: 600 !important;\n  padding: 16px 12px !important;\n}\n\n.dark-table .ant-table-tbody > tr > td {\n  background: var(--dark-bg) !important;\n  border-bottom: 1px solid var(--dark-border) !important;\n  color: var(--dark-text) !important;\n  padding: 12px !important;\n}\n\n.dark-table .ant-table-tbody > tr:hover > td {\n  background: var(--dark-bg-secondary) !important;\n}\n\n/* Light mode table styles */\n.ant-table-thead > tr > th {\n  background: #fafafa !important;\n  border-bottom: 2px solid #d9d9d9 !important;\n  color: #333 !important;\n  font-weight: 600 !important;\n  padding: 16px 12px !important;\n}\n\n.ant-table-tbody > tr > td {\n  background: #fff !important;\n  border-bottom: 1px solid #f0f0f0 !important;\n  color: #333 !important;\n  padding: 12px !important;\n}\n\n.ant-table-tbody > tr:hover > td {\n  background: #f5f5f5 !important;\n}\n\n/* Row spacing */\n.table-row-even {\n  margin-bottom: 4px;\n}\n\n.table-row-odd {\n  margin-bottom: 4px;\n}\n\n/* Modal dark mode styles */\nbody[data-theme='dark'] .ant-modal-content {\n  background-color: var(--dark-bg-secondary) !important;\n  border: 1px solid var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-modal-header {\n  background-color: var(--dark-bg-header) !important;\n  border-bottom: 1px solid var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-modal-title {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-modal-close {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-modal-body {\n  background-color: var(--dark-bg-secondary) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-modal-footer {\n  background-color: var(--dark-bg-secondary) !important;\n  border-top: 1px solid var(--dark-border) !important;\n}\n\n/* Select dark mode styles */\nbody[data-theme='dark'] .ant-select-selector {\n  background-color: var(--dark-bg) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-select-selection-item {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-select-selection-placeholder {\n  color: var(--dark-text-muted) !important;\n}\n\nbody[data-theme='dark'] .ant-select-arrow {\n  color: var(--dark-text-muted) !important;\n}\n\nbody[data-theme='dark'] .ant-select-dropdown {\n  background-color: var(--dark-bg-secondary) !important;\n  border: 1px solid var(--dark-border) !important;\n}\n\n/* Popconfirm/Popover in form area */\nbody[data-theme='dark'] .ant-popover-inner,\nbody[data-theme='dark'] .ant-popconfirm .ant-popover-inner {\n  background-color: var(--dark-bg-secondary) !important;\n  color: var(--dark-text) !important;\n}\nbody[data-theme='dark'] .ant-popover-inner-content {\n  color: var(--dark-text) !important;\n}\nbody[data-theme='dark'] .ant-popover-arrow::before {\n  background: var(--dark-bg-secondary) !important;\n}\n\nbody[data-theme='dark'] .ant-select-item {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-select-item-option-selected {\n  background-color: var(--dark-bg-header) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-select-item-option:hover {\n  background-color: var(--dark-bg-header) !important;\n}\n\n/* Tooltip dark mode styles */\nbody[data-theme='dark'] .ant-tooltip-inner {\n  background-color: var(--dark-bg-header) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-tooltip-arrow::before {\n  background-color: var(--dark-bg-header) !important;\n}\n\n/* Alert dark mode styles */\nbody[data-theme='dark'] .ant-alert {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-alert-message {\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-alert-description {\n  color: var(--dark-text-muted) !important;\n}\n\n/* Spin dark mode styles */\nbody[data-theme='dark'] .ant-spin-dot-item {\n  background-color: var(--color-primary) !important;\n}\n\nbody[data-theme='dark'] .ant-spin-text {\n  color: var(--dark-text) !important;\n}\n\n/* Descriptions dark mode styles */\nbody[data-theme='dark'] .ant-descriptions {\n  background-color: var(--dark-bg-secondary) !important;\n  color: var(--dark-text) !important;\n}\n\nbody[data-theme='dark'] .ant-descriptions-item-label {\n  color: var(--dark-text) !important;\n  background-color: var(--dark-bg-header) !important;\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-descriptions-item-content {\n  color: var(--dark-text) !important;\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-descriptions-bordered .ant-descriptions-item-label {\n  background-color: var(--dark-bg-header) !important;\n  border-color: var(--dark-border) !important;\n}\n\nbody[data-theme='dark'] .ant-descriptions-bordered .ant-descriptions-item-content {\n  background-color: var(--dark-bg-secondary) !important;\n  border-color: var(--dark-border) !important;\n}\n\n/* Table Summary dark mode styles */\nbody[data-theme='dark'] .ant-table-summary {\n  background-color: var(--dark-bg-secondary) !important;\n}\n\nbody[data-theme='dark'] .ant-table-summary tr > td {\n  background-color: var(--dark-bg-header) !important;\n  border-color: var(--dark-border) !important;\n  color: var(--dark-text) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
